"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBillingInformations = exports.LoadingIndicator = exports.ondateChange = exports.mapStateToProps = void 0;
var React = require("react");
var fp = require("fp-ts");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var BillingInformationsActions = require("@caddigital/sok-reducers/lib/actions/order/billingInformations");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var helpers_1 = require("../../helpers");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var BillingInformation_1 = require("../../../../components/BillingInformation");
var DatePicker_1 = require("components/DatePicker");
var InvalidFiles_1 = require("../../../../components/InvalidFiles");
var Types = require("types");
var mapStateToProps = function (state) { return ({
    user: state.auth.current.user,
    author: state.order.wizard.values.author,
    values: state.order.wizard.values,
    checkingFiles: state.order.wizard.checkingFiles,
    billingInformations: state.order.billingInformations,
    cartItems: state.cart.data.items,
    billingInformation: state.order.wizard.values.billingInformation
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    setProjectBilling: function (project) {
        return dispatch(WizardActions.setBillingInformationProject(project));
    },
    toggleProceedWithoutInvalidFiles: function () {
        return dispatch(WizardActions.proceedWithoutInvalidFiles());
    },
    setName: function (value) { return dispatch(WizardActions.valuesSetName(value)); },
    setBillingInformation: function (value) {
        return dispatch(WizardActions.valuesSetBillingInformation(value));
    },
    setDesiredDeliveryTime: function (date) {
        return dispatch(WizardActions.valuesSetRequestTimeOfDelivery(date.format('YYYY-MM-DD HH:mm:ssZZ')));
    },
    fetchBillingInformations: function (project) { return function () {
        return dispatch(BillingInformationsActions.fetchBillingInformationsRequest(project));
    }; },
    updateCustomBillingInformations: function (key) { return function (value) {
        return dispatch(WizardActions.valuesUpdateCustomBillingInformationField(key, value));
    }; },
    prevalidateFiles: function (folder, files, type) {
        return dispatch(WizardActions.prevalidateFilesRequest(folder.id, files, type));
    }
}); };
//#region Types
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var ondateChange = function (props) { return function (selected) {
    var m = selected.set('seconds', 0);
    // if selected date is currentdate and selectedhour is current hour then set clock +1
    var currDate = moment(new Date());
    if (moment(m).isSame(currDate, 'day') && m.hours() < currDate.hours()) {
        props.setDesiredDeliveryTime(moment(m)
            .hours(moment().hours() + 1)
            .minutes(moment().minutes()));
    }
    else {
        props.setDesiredDeliveryTime(m);
    }
}; };
exports.ondateChange = ondateChange;
var LoadingIndicator = function () { return (React.createElement("div", { className: 'grid-spinner' },
    React.createElement(sok_ui_1.LoadingSpinner, null),
    ' ',
    (0, translation_1.getLocalization)('userfront/shoppingcart/step1/loadingText'))); };
exports.LoadingIndicator = LoadingIndicator;
var filterBillingInformations = function (billingInformations) {
    return billingInformations.reduce(function (arr, billing) {
        var contains = arr.find(function (x) { return x.customerName === billing.customerName; });
        if (!contains) {
            arr.push(billing);
        }
        return arr;
    }, []);
};
exports.filterBillingInformations = filterBillingInformations;
var OrderName = (0, recompose_1.compose)((0, recompose_1.withState)('value', 'setValue', null), recompose_1.pure)(function (props) {
    var value = '';
    if (props.value === null) {
        value = props.values.name;
    }
    else {
        value = props.value;
    }
    return (React.createElement(sok_ui_1.TextInput, { key: "input-name", name: 'order-name', className: 'white', value: value, onChange: function (e) { return props.setValue(e.target.value); }, onBlur: function () {
            if (value === props.values.name) {
                return;
            }
            props.setName(value);
            props.setValue(null);
        }, disabled: props.disableWizardFields }));
});
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('OrderWizardStep1'), (0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), recompose_1.pure);
var component = enhance(function (props) {
    // Resets timeOfDelivery for automatic order and reorders
    React.useEffect(function () {
        if (props.mode === 'EDIT') {
            props.setDesiredDeliveryTime((0, helpers_1.initDate)());
        }
    }, []);
    if ((props.type !== 'AUTOMATIC' && props.checkingFiles.status === 'FAILED') ||
        (props.type === 'AUTOMATIC' &&
            props.checkingFiles.status === 'FAILED' &&
            props.cartItems.length > 0 &&
            !(0, InvalidFiles_1.containsInvalidFiles)(props.cartItems))) {
        return (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
            React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                    return props.prevalidateFiles(props.currentFolder, props.cartItems.map(function (x) { return x.id; }), props.type);
                }, children: (0, translation_1.getLocalization)('generic/tryAgain') })));
    }
    return (React.createElement("div", { className: 'order-wizard-step1' },
        React.createElement("div", { className: 'disclaimer' },
            React.createElement("div", null, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/informationText'))),
        React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { extraSmall: 5, small: 3 },
                React.createElement("label", { htmlFor: 'ordered-by' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/orderedBy'))),
            React.createElement(sok_ui_1.Column, { extraSmall: 7, small: 9 }, props.mode === 'VIEW' && props.author
                ? "".concat(props.author.firstName, " ").concat(props.author.lastName, " ").concat(props.author.company)
                : props.user.map(function (x) { return x.company; }).getOrElse('-'))),
        React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { extraSmall: 5, small: 3 },
                React.createElement("label", { htmlFor: 'contact-person' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/contactPerson'))),
            React.createElement(sok_ui_1.Column, { extraSmall: 7, small: 9 }, props.author
                ? props.author.email
                : props.user.map(function (x) { return x.email; }).getOrElse('-'))),
        React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { extraSmall: 5, small: 3 },
                React.createElement("label", { htmlFor: 'order date' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/orderDate'))),
            React.createElement(sok_ui_1.Column, { extraSmall: 7, small: 9 }, props.values.createdAt
                ? moment(props.values.createdAt).format('L LT')
                : moment(props.values.orderDate).format('L LT'))),
        React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { extraSmall: 5, small: 3 },
                React.createElement("label", { htmlFor: 'project' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/projectName'))),
            React.createElement(sok_ui_1.Column, { extraSmall: 7, small: 9 }, props.currentProject ? (props.currentProject.name) : (React.createElement(exports.LoadingIndicator, null)))),
        (props.checkingFiles.status === 'INVALID' ||
            (0, InvalidFiles_1.containsInvalidFiles)(props.cartItems)) &&
            props.mode === 'CREATE' && (React.createElement(InvalidFiles_1.default, { mode: props.mode, toggleProceedWithoutInvalidFiles: props.toggleProceedWithoutInvalidFiles, proceedWithoutInvalidFiles: props.values.proceedWithoutInvalidFiles, status: props.values.status, errors: props.values.status === 'ERROR' ? props.values.errors : {} })),
        React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { small: 3 },
                React.createElement("label", { htmlFor: 'order-name' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/orderName'))),
            React.createElement(sok_ui_1.Column, { small: 9 },
                React.createElement(OrderName, __assign({}, props)),
                props.values.status === 'ERROR' && props.values.errors['name'] && (React.createElement("p", { className: 'validation-error' }, props.values.errors['name'][0])))),
        props.billingInformations.status === 'FETCHING' && React.createElement(exports.LoadingIndicator, null),
        props.billingInformations.status === 'FETCHED' && (React.createElement(BillingInformation_1.default, { setBillingInformation: props.setBillingInformation, items: props.billingInformations.list, selected: props.billingInformation, errors: props.values.status === 'ERROR'
                ? fp.option.some(props.values.errors)
                : fp.option.none, disable: props.disableWizardFields })),
        props.billingInformations.status === 'FAILED' && (React.createElement("div", null,
            (0, translation_1.getLocalization)('userfront/shoppingcart/step1/fetchBillingInformation/failed'),
            ' ',
            React.createElement("span", { className: 'error-button', onClick: props.currentProject &&
                    props.fetchBillingInformations(props.currentProject) }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/fetchBillingInformation/tryAgain')))),
        props.type === 'SINGLE' && (React.createElement(sok_ui_1.Row, { className: 'requested-delivery-container' },
            React.createElement(sok_ui_1.Column, { small: 3 },
                React.createElement("label", { htmlFor: 'requested-time' }, (0, translation_1.getLocalization)('userfront/shoppingcart/step1/requestedTimeOfDelivery'))),
            React.createElement(sok_ui_1.Column, { small: 9 },
                React.createElement(DatePicker_1.DatePicker, { selected: moment(props.values.requestTimeOfDelivery), onChange: (0, exports.ondateChange)(props), showTimeSelect: true, timeCaption: (0, translation_1.getLocalization)('datePicker/time'), alignment: 'center', minDate: (0, helpers_1.setMinDate)(), minTime: (0, helpers_1.excludeLast24orOverOfficeHour)(props.values.requestTimeOfDelivery), maxTime: moment().hours(16).minutes(0), filterDate: helpers_1.isWeekday, timeIntervals: 30, dateFormat: "LLL", timeFormat: "HH:mm", disabled: props.disableWizardFields }))))));
});
exports.default = component;
